import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const separatorCss = {
  border: "none",
  borderBottom: `1px solid ${ui.neutral[100]}`,
  margin: "25px 0",
};
